import { render, staticRenderFns } from "./ComplementaryExamsPerPrenatalConsultation.vue?vue&type=template&id=7c72d3c4&scoped=true"
import script from "./ComplementaryExamsPerPrenatalConsultation.vue?vue&type=script&lang=js"
export * from "./ComplementaryExamsPerPrenatalConsultation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c72d3c4",
  null
  
)

export default component.exports